export function parseStoredTestNames(value?: string | null): string[] {
  if (!value?.trim()) {
    return [];
  }

  const trimmed = value.trim();
  if (trimmed.startsWith('[')) {
    try {
      const parsed = JSON.parse(trimmed);
      if (Array.isArray(parsed)) {
        return parsed.map(name => String(name ?? '').trim()).filter(Boolean);
      }
    } catch {
      // Fall through to legacy comma-separated format.
    }
  }

  return trimmed
    .split(',')
    .map(name => name.trim())
    .filter(Boolean);
}

export function formatStoredTestNamesDisplay(value?: string | null): string {
  const names = parseStoredTestNames(value);
  if (!names.length) {
    return '';
  }
  return names.join(', ');
}

export function serializeStoredTestNames(names: string[]): string {
  const unique: string[] = [];
  const seen = new Set<string>();

  for (const raw of names) {
    const trimmed = String(raw || '').trim();
    if (!trimmed) {
      continue;
    }
    const key = trimmed.toLowerCase();
    if (seen.has(key)) {
      continue;
    }
    seen.add(key);
    unique.push(trimmed);
  }

  if (!unique.length) {
    return '';
  }
  return JSON.stringify(unique);
}
